var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.notPositon ? 'yellowTitle_' : 'yellowTitle',attrs:{"id":_vm.failed ? 'failed' : ''}},[_vm._v(" "+_vm._s(_vm.info)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }